export const ADD_ARTICLE = "ADD_ARTICLE";
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const VERIFY = "VERIFY";
export const UPDATE_DASHBOARD_TABLE = "UPDATE_DASHBOARD_TABLE";
export const UPDATE_DASHBOARD_SEARCH = "UPDATE_DASHBOARD_SEARCH";
